export default "__VITE_ASSET__plhSw6GZ__"